import { Layout, Section } from 'layout/index';
import { UsersListScreen } from 'pages/user-management/screens/users-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const UserManagementPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={UsersListScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default UserManagementPage;
